import React, { useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import * as Menu from '@radix-ui/react-menu'
import { useTabletDownMediaQuery } from 'utils/hooks/useMediaQueries'
import ReleaseActionsMenuContent, {
  menuContentClassName
} from './ReleaseActionsMenuContent'

const createVirtualAnchor = ({ x, y }) => ({
  getBoundingClientRect: () => ({
    bottom: y,
    height: 0,
    left: x,
    right: x,
    top: y,
    width: 0,
    x,
    y,
    toJSON: () => ({})
  })
})

const ReleaseContextMenu = ({ children, release }) => {
  const [open, setOpen] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const isTabletDown = useTabletDownMediaQuery()
  const theme = useTheme()
  const child = React.Children.only(children)
  const virtualAnchor = useMemo(
    () => createVirtualAnchor(position),
    [position]
  )
  const virtualRef = useRef(virtualAnchor)
  virtualRef.current = virtualAnchor

  const handleContextMenuCapture = (event) => {
    if (child.props.onContextMenuCapture) {
      child.props.onContextMenuCapture(event)
    }

    if (isTabletDown) return

    event.preventDefault()
    setPosition({ x: event.clientX, y: event.clientY })
    setOpen(true)
  }

  return (
    <Menu.Root onOpenChange={setOpen} open={open}>
      <Menu.Anchor virtualRef={virtualRef} />
      {React.cloneElement(child, {
        'data-context-menu-open': open,
        onContextMenuCapture: handleContextMenuCapture
      })}
      <Menu.Portal>
        <Menu.Content
          align="start"
          avoidCollisions
          className={menuContentClassName}
          collisionPadding={8}
          data-cy="release-context-menu"
          onCloseAutoFocus={(event) => event.preventDefault()}
          side="right"
          sideOffset={4}
          style={{
            background: theme.colors.neutralW20,
            color: theme.colors.neutralW100
          }}>
          <ReleaseActionsMenuContent
            Menu={Menu}
            release={release}
            source="releases_view_release_context_menu"
          />
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  )
}

ReleaseContextMenu.propTypes = {
  children: PropTypes.element.isRequired,
  release: PropTypes.object.isRequired
}

export default ReleaseContextMenu
